import type { ToastOptions } from 'vue-toastification/dist/types/types';
import type { ToastContentProps } from '../types/toast.types';
import type { useCustomToast } from '../use/useCustomToast';

type ToastAdapter = Pick<ReturnType<typeof useCustomToast>, 'showSuccessToast' | 'showErrorToast'>;

function buildToastProps(title: string, message: string, type: ToastContentProps['type']) {
  return {
    title,
    message,
    type,
  };
}

export function toastSuccess(
  toast: ToastAdapter,
  title: string,
  message = '',
  options?: Partial<ToastOptions>
) {
  toast.showSuccessToast(buildToastProps(title, message, 'success'), options);
}

export function toastError(
  toast: ToastAdapter,
  title: string,
  message = '',
  options?: Partial<ToastOptions>
) {
  toast.showErrorToast(buildToastProps(title, message, 'error'), options);
}
